import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [pathname]);

  const linkClass = (path: string) =>
    `text-sm font-medium whitespace-nowrap transition-colors duration-300 ${
      pathname === path
        ? "text-primary-500"
        : "text-foreground-700 hover:text-primary-500"
    }`;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="text-xl font-semibold whitespace-nowrap tracking-wide"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            <span className="text-primary-500">苍井优</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={linkClass("/")}>
              首页
            </Link>
            <Link to="/category/film" className={linkClass("/category/film")}>
              电影作品
            </Link>
            <Link to="/category/drama" className={linkClass("/category/drama")}>
              电视剧
            </Link>
            <Link to="/category/stage" className={linkClass("/category/stage")}>
              舞台剧
            </Link>
            <Link
              to="/category/awards"
              className={linkClass("/category/awards")}
            >
              获奖经历
            </Link>
            <Link to="/category/news" className={linkClass("/category/news")}>
              最新动态
            </Link>
            <Link to="/about" className={linkClass("/about")}>
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
            aria-label="切换菜单"
          >
            <i
              className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}
            ></i>
          </button>
        </div>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          mobileOpen ? "max-h-[420px]" : "max-h-0"
        }`}
      >
        <div className="px-6 py-4 bg-background-50/98 backdrop-blur-md flex flex-col gap-3 border-t border-background-200/50">
          <Link to="/" className={linkClass("/")}>
            首页
          </Link>
          <Link to="/category/film" className={linkClass("/category/film")}>
            电影作品
          </Link>
          <Link to="/category/drama" className={linkClass("/category/drama")}>
            电视剧
          </Link>
          <Link to="/category/stage" className={linkClass("/category/stage")}>
            舞台剧
          </Link>
          <Link
            to="/category/awards"
            className={linkClass("/category/awards")}
          >
            获奖经历
          </Link>
          <Link to="/category/news" className={linkClass("/category/news")}>
            最新动态
          </Link>
          <Link to="/about" className={linkClass("/about")}>
            关于我们
          </Link>
        </div>
      </div>
    </nav>
  );
}